<template>
  <div class="w-full h-full flex-grow">
    <div
      class="flex justify-center items-center space-x-3 text-gray-600 text-sm w-full h-full flex-grow"
    >
      <div class="flex h-full items-center space-x-1">
        <div class="animate-bounce animation-delay-200">
          <div class="h-1.5 w-1.5 rounded-full bg-gray-400"></div>
        </div>
        <div class="animate-bounce animation-delay-300">
          <div class="h-1.5 w-1.5 rounded-full bg-gray-400"></div>
        </div>
        <div class="animate-bounce animation-delay-400">
          <div class="h-1.5 w-1.5 rounded-full bg-gray-400"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
